
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"コンポーネント 80 – 1","xmlns":"http://www.w3.org/2000/svg","width":"33","height":"33"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"data-name":"楕円形 30","cx":"16.5","cy":"16.5","r":"16.5","fill":"#1a62a5"}}),_c('path',{attrs:{"d":"M22.723 24.2v-9.9H9.84v9.9h12.883M19.962 8H21.8v1.8h.92a1.82 1.82 0 011.84 1.8v12.6a1.814 1.814 0 01-1.84 1.8H9.84A1.82 1.82 0 018 24.2V11.6a1.814 1.814 0 011.84-1.8h.92V8h1.84v1.8h7.361V8m-4.6 7.65H17.2v2.7h2.76v1.8H17.2v2.7h-1.84v-2.7H12.6v-1.8h2.76z","fill":"#fff"}})])
          )
        }
      }
    